import { render, staticRenderFns } from "./DriverSummaryTable.vue?vue&type=template&id=01f363af&scoped=true&"
import script from "./DriverSummaryTable.vue?vue&type=script&lang=js&"
export * from "./DriverSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./DriverSummaryTable.vue?vue&type=style&index=0&id=01f363af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f363af",
  null
  
)

export default component.exports